document.addEventListener("alpine:init", () => {
  Alpine.data(
    "Theme_SlideshowV2",
    ({
      autoplay = false,
      autoplayInterval = null,
      mode = "slideshow",
      gap = null,
      onlyIfNeeded = false,
      options = {},
      pagination = true,
    }) => ({
      autoplay,
      autoplayInterval,
      playing: false,
      splide: null,
      options,
      rate: 0,
      pagination,
      mode,
      gap,
      onlyIfNeeded,
      swiperEl: null,
      maxLgBreakpointMQL: window.matchMedia("(max-width: 1023px)"),
      init(){
        this.initSlideshow();
      },
      initSlideshow() {
        if (typeof Swiper === "undefined") {
          console.error(
            "slideshows-v2.js requires a Swiper object to be defined in the global scope"
          );

          return;
        }
        if(this.$refs.swiperEl){
          this.swiperEl = this.$refs.swiperEl;
        }else{
          this.swiperEl = this.$el;
        }

        this.initSwiper();
        const _this = this;
        if (this.$refs.progressBar) {
          this.$root.addEventListener("move", function (evt) {
            _this.$refs.progressBar.style.width =
              evt.detail.progress.toString() + "%";
          });
        }

        if (this.onlyIfNeeded) {
          this.destroyOrInitIfNeeded();

          this.maxLgBreakpointMQL.addEventListener("change", (e) => {
            this.destroyOrInitIfNeeded();
          });
        }

        if (Shopify.designMode) {
          this._setUpDesignModeHandlers();
        }

        document.addEventListener("dev:hotreloadmutation", async () => {
          if (!Shopify.designMode) {
            this.swiper.destroy();

            await this.$nextTick();

            this.initSwiper();
          }
        });
      },
      initSwiper() {
        if(this.swiper){
          this.swiper.init(this.swiperEl);
        }
        const options = {
          ...this.options,
          spaceBetween: this.gap,
        };
        if (this.pagination) {
          options["pagination"] = {
            el: this.$refs.swiperPagination || this.$root.querySelector('.swiper-pagination'),
            bulletClass: 'mic-pagination-bullet',
            bulletActiveClass: 'active',
            type: 'bullets',
            clickable: true,
          };
          console.log(options["pagination"]);
          options['hashNavigation'] = {
            watchState: true,
          }
        }
        if (this.autoplay) {
          options["autoplay"] = {
            delay: this.autoplayInterval,
          };
        }
          
        this.swiper = new Swiper(this.swiperEl, options);

        if (options.autoplay) {
          this.swiper.on("autoplayStart", () => {
            this.playing = true;
          });
          this.swiper.on("autoplayResume", () => {
            this.playing = true;
          });
          this.swiper.on("autoplayPause", () => {
            this.playing = false;
          });
          this.swiper.on("autoplayStop", () => {
            this.playing = false;
          });
          this.swiper.on("autoplayTimeLeft", (swiper, timeLeft, rate) => {
            this.rate = rate;
          });
        }
      },
      destroyOrInitIfNeeded() {
        const slideEls = Array.from(
          this.$root.querySelectorAll(".swiper-slide")
        );

        const totalSlidesWidth = slideEls.reduce(
          (totalWidth, slideEl) =>
            totalWidth + slideEl.getBoundingClientRect().width,
          0
        );

        const totalGridlinesWidth =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              "--gridline-width"
            )
          ) *
          (slideEls.length - 1);

        const totalContentWidth = totalSlidesWidth + totalGridlinesWidth;

        if (totalContentWidth <= this.$root.getBoundingClientRect().width) {
          this.swiper.destroy();
        } else {
            this.initSwiper();
        }
      },
      _setUpDesignModeHandlers() {
        this.$root.addEventListener("slideshow-go", (e) => {
          if (!e.detail) return;

          this.swiper.go(parseInt(e.detail, 10));
        });
      },
    })
  );
});
